import React, { useState, useEffect } from "react";
import { ProgramCard, ProgramViewEdit } from "../../components";
import { handleApi } from "../../utils/authentication";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { UPDATE_USER_DATA } from "../../redux/features/user/userSlice";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/client/LoadingSpinner";

const ClientPrograms = () => {
  const [activeTab, setActiveTab] = useState("all_programs");
  const [show, setShow] = useState(false);
  const [programList, setProgramList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state) => state?.user);
  const [programId, setProgramId] = useState();
  const dispatch = useDispatch();
  const { client_id } = useParams();

  //get program list

  const getProgramList = async () => {
    try {
      setIsLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("client_id", client_id);

      formData.append("role_id", user?.role_id);

      let result = await handleApi(`program_list`, method, headers, formData);
      if (result?.success) {
        setProgramList(
          result?.data?.programs_list.sort((a, b) => {
            const nameA = a.program_name.toUpperCase();
            const nameB = b.program_name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }),
        );
        dispatch(
          UPDATE_USER_DATA({
            count_of_programs: result?.data?.programs_list?.length,
          }),
        );
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to fetch program list",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          },
        );
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message ? e?.message : "Failed to fetch program list", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProgramList();
  }, [client_id, show]);

  return (
    <div className="row  d-flex m-0  gap-3 w-100 ">
      <div className="row campaign_header_tab d-flex align-items-center   ">
        <div className="col-lg-10 col-md-12 row ">
          <div className="col-lg-2 col-md-3 ">
            <span href="" onClick={() => setActiveTab("all_programs")}>
              <p
                className={`mb-0 ${activeTab === "all_programs" && "campaign_header_tab_active"}`}
              >
                All Programs ({programList?.length ? programList?.length : 0})
              </p>
              {activeTab === "all_programs" && (
                <div
                  style={{ border: "solid 1px #7f56d9" }}
                  className="underline"
                >
                  {" "}
                </div>
              )}
            </span>
          </div>
          <div className="col-lg-2 col-md-3 text-center">
            <span href="" onClick={() => setActiveTab("mine_programs")}>
              <p
                className={`mb-0 ${activeTab === "mine_programs" && "campaign_header_tab_active"}`}
              >
                Mine (0)
              </p>
              {activeTab === "mine_programs" && (
                <div
                  style={{ border: "solid 1px #7f56d9" }}
                  className="underline"
                >
                  {" "}
                </div>
              )}
            </span>
          </div>
          <div className="col-lg-2 col-md-3 text-center">
            <span href="" onClick={() => setActiveTab("completed_programs")}>
              <p
                className={`mb-0 ${activeTab === "completed_programs" && "campaign_header_tab_active"}`}
              >
                Completed (0)
              </p>
              {activeTab === "completed_programs" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>
          </div>
          <div className="col-lg-2 col-md-3 text-center">
            <span href="" onClick={() => setActiveTab("archived_programs")}>
              <p
                className={`mb-0 ${activeTab === "archived_programs" && "campaign_header_tab_active"}`}
              >
                Archived (0)
              </p>
              {activeTab === "archived_programs" && (
                <div style={{ border: "solid 1px #7f56d9" }}> </div>
              )}
            </span>
          </div>

          <div className="col-lg-4 col-md-4"></div>
        </div>
        <div className="col-lg-2 col-md-4 d-flex justify-content-lg-end">
          {(user?.role_id === 2 || user?.role_id === 1) && (
            <button
              style={{ marginRight: "-7.5vw" }}
              onClick={() => {
                setShow(true);
                setProgramId(null);
              }}
              className="btn btn-md  rounded-pill  btn-primary nav_export_stats_btn"
            >
              Create Program
            </button>
          )}
        </div>
      </div>
      <div className="card campaign_card">
        <div className="d-flex justify-content-between align-items-center  campaign_card_heading ">
          <p className="mb-0">PROGRAMS LIST</p>
          <p> </p>
        </div>
        {programList &&
          programList?.length > 0 &&
          programList.map((program) => {
            return (
              <ProgramCard
                key={program?.program_id}
                program={program}
                setProgramId={setProgramId}
                setShow={setShow}
              />
            );
          })}

        {isLoading && (
          <div className="position-absolute top-50 end-50">
            <LoadingSpinner />
          </div>
        )}
        {!isLoading && programList && programList.length === 0 && (
          <div style={{ position: "absolute", left: "37%", top: "50%" }}>
            <div className=" w-full " role="status">
              <h5>No Progrmas To Display</h5>
            </div>
          </div>
        )}
      </div>
      <ProgramViewEdit
        program_id={programId}
        setProgramId={setProgramId}
        show={show}
        setShow={setShow}
      />
    </div>
  );
};

export default ClientPrograms;
